import {
  OreTable,
  OreTableBody,
  OreTableCaption,
  OreTableCell,
  OreTableContainer,
  OreTableRow,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { BankAccountChangeForm } from '@/Contract/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

type BankAccountChangeFormKeys = keyof BankAccountChangeForm

export const Step2Resume = (): JSX.Element => {
  const { t } = useTranslation()
  const { changeForm, availablePhones } = useBankAccount()

  const displayFields: BankAccountChangeFormKeys[] = [
    'newIban',
    'signerName',
    'signerSurname1',
    'signerSurname2',
    'signerDocumentType',
    'signerDocument',
    'signerPhoneId',
  ]

  const documentTypeTranslation = {
    1: t(formTranslation.common.identifier.documentType.dni),
    2: t(formTranslation.common.identifier.documentType.passport),
  }

  return (
    <OreTableContainer>
      <OreTable>
        <OreTableCaption title={t(contractTranslation.changeBankAccount.step2.title2)} />
        <OreTableBody>
          {displayFields.map((field, index) => {
            if (field === 'signerSurname2' && !changeForm.getValues(field)) return null
            return (
              <OreTableRow key={index}>
                <OreTableCell align="left">
                  <OreText align="left">
                    {t(
                      contractTranslation.changeBankAccount.form.data[
                        field as keyof typeof contractTranslation.changeBankAccount.form.data
                      ]?.label,
                    )}
                  </OreText>
                </OreTableCell>

                <OreTableCell align="right">
                  <OreText bold align="right">
                    {field === 'signerDocumentType'
                      ? documentTypeTranslation[changeForm.getValues(field) || 1]
                      : field === 'signerPhoneId'
                        ? availablePhones.find(
                            phone => phone.id == changeForm.getValues(field),
                          )?.maskedPhoneNumber
                        : changeForm.getValues(field)}
                  </OreText>
                </OreTableCell>
              </OreTableRow>
            )
          })}
        </OreTableBody>
      </OreTable>
    </OreTableContainer>
  )
}
